<template>
  <div class="row">
    <div class="col-xl-3 col-sm-6 mb-3">
      <div class="card text-white bg-primary o-hidden h-100 border-none">
        <div class="card-body">
          <div class="card-body-icon">
            <i class="fas fa-fw fa-users" />
          </div>
          <div class="mr-5"><b>26</b> Channels</div>
        </div>
        <a
          class="card-footer text-white clearfix small z-1"
          href="#"
        >
          <span class="float-left">View Details</span>
          <span class="float-right">
            <i class="fas fa-angle-right" />
          </span>
        </a>
      </div>
    </div>
    <div class="col-xl-3 col-sm-6 mb-3">
      <div class="card text-white bg-warning o-hidden h-100 border-none">
        <div class="card-body">
          <div class="card-body-icon">
            <i class="fas fa-fw fa-video" />
          </div>
          <div class="mr-5"><b>156</b> Videos</div>
        </div>
        <a
          class="card-footer text-white clearfix small z-1"
          href="#"
        >
          <span class="float-left">View Details</span>
          <span class="float-right">
            <i class="fas fa-angle-right" />
          </span>
        </a>
      </div>
    </div>
    <div class="col-xl-3 col-sm-6 mb-3">
      <div class="card text-white bg-success o-hidden h-100 border-none">
        <div class="card-body">
          <div class="card-body-icon">
            <i class="fas fa-fw fa-list-alt" />
          </div>
          <div class="mr-5"><b>123</b> Categories</div>
        </div>
        <a
          class="card-footer text-white clearfix small z-1"
          href="#"
        >
          <span class="float-left">View Details</span>
          <span class="float-right">
            <i class="fas fa-angle-right" />
          </span>
        </a>
      </div>
    </div>
    <div class="col-xl-3 col-sm-6 mb-3">
      <div class="card text-white bg-danger o-hidden h-100 border-none">
        <div class="card-body">
          <div class="card-body-icon">
            <i class="fas fa-fw fa-cloud-upload-alt" />
          </div>
          <div class="mr-5"><b>13</b> New Videos</div>
        </div>
        <a
          class="card-footer text-white clearfix small z-1"
          href="#"
        >
          <span class="float-left">View Details</span>
          <span class="float-right">
            <i class="fas fa-angle-right" />
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
